import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonOlList from '../../../common-components/common-ol-list';

const taskList = {
    colorNumber: '#7927E0',
    list: [
        'Донести преимущества продуктов Фонда до целевой аудитории',
        'Повысить лояльность со стороны предпринимателей',
        'Охватить новую аудиторию с помощью инструментов платного трафика и оптимизации сайта',
    ],
};

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="zkhfoundation-tasks" bigPaddings={false}>
                <div className="zkhfoundation-tasks__wrapper">
                    <div className="zkhfoundation-tasks__info">
                        <CommonTitle className="zkhfoundation-tasks__title">
                            Задачи проекта:
                        </CommonTitle>
                        <CommonOlList
                            className="zkhfoundation-tasks__list"
                            CommonOlList={taskList}
                        />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
